var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferredBy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50211",
    "data-name": "Group 50211",
    transform: "translate(440.884 -1701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95206",
    "data-name": "Path 95206",
    d: "M24.533,11.6H19.682V9.625A1.47,1.47,0,0,0,18.3,8.082H11.93a1.47,1.47,0,0,0-1.38,1.543V11.6H5.7a2.752,2.752,0,0,0-2.583,2.888v14.7A2.751,2.751,0,0,0,5.7,32.082H24.531a2.752,2.752,0,0,0,2.583-2.888l0-14.7A2.751,2.751,0,0,0,24.534,11.6Zm-3.189.895H23.42V15.77H21.344Zm0,4.168H23.42v1.919H21.344Zm0,2.814H23.42v2.563a1.044,1.044,0,1,1-2.076,0ZM11.352,9.625a.618.618,0,0,1,.58-.649H18.3a.618.618,0,0,1,.58.649V11.6h-7.53V9.625ZM9.691,12.5H20.545V20.48l-3.471.581v-.841a1.075,1.075,0,0,0-1.009-1.128H14.17a1.075,1.075,0,0,0-1.009,1.128v.841L9.691,20.48Zm6.583,7.724v3.6a.222.222,0,0,1-.209.234H14.17a.223.223,0,0,1-.209-.234v-3.6a.222.222,0,0,1,.209-.234h1.895a.223.223,0,0,1,.209.234ZM6.814,12.5H8.89V15.77H6.814Zm0,4.168H8.89v1.919H6.814Zm0,2.814H8.89v2.563A1.1,1.1,0,0,1,7.854,23.2a1.106,1.106,0,0,1-1.04-1.159Zm-2.9-4.987A1.9,1.9,0,0,1,5.7,12.5h.314v7.37l-2.1-.35V14.49Zm22.4,14.7a1.9,1.9,0,0,1-1.783,1.994H5.7a1.9,1.9,0,0,1-1.783-1.994V20.422l2.1.35v1.269a1.957,1.957,0,0,0,1.84,2.053A1.954,1.954,0,0,0,9.69,22.041v-.658l3.471.581v1.85a1.075,1.075,0,0,0,1.009,1.128h1.895a1.075,1.075,0,0,0,1.009-1.128v-1.85l3.471-.581v.658a1.956,1.956,0,0,0,1.836,2.053,1.959,1.959,0,0,0,1.84-2.053V20.772l2.1-.35Zm0-9.676-2.1.35V12.5h.313a1.9,1.9,0,0,1,1.783,1.994v5.028Z",
    transform: "translate(-444 1692.918)",
    fill: "#959ba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95207",
    "data-name": "Path 95207",
    d: "M50.031,55.2h-.016a1.57,1.57,0,1,0,.016,0Z",
    transform: "translate(-478.904 1657.987)",
    fill: "#959ba6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferredBy);
export default __webpack_public_path__ + "static/media/referred-by.b9fd10c9a33fbad4750a88515bc7bbbe.svg";
export { ForwardRef as ReactComponent };